import { useAuth } from "contexts/AuthProvider";

/** Returns true when the account is scheduled for deletion. */
export function useAccountScheduledForDeletion(): boolean {
  const { accountStatus } = useAuth();
  return accountStatus === "scheduledfordeletion";
}
